module.exports = __webpack_public_path__ + "static/media/temp-persona-11.af6d78b0.jpg";